import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Shield } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  const sections = t('privacy.sections', { returnObjects: true });

  return (
    <div className="min-h-screen py-16" data-testid="privacy-policy-page">
      <Helmet>
        <title>Privacy Policy | Tasty Bites - Halal Food Takeaway Lugano</title>
        <meta name="description" content="Privacy policy for Tasty Bites. Learn how we handle your data under Swiss data protection law (nFADP)." />
        <link rel="canonical" href="https://www.tastybiteslugano.ch/privacy" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-[#FFC107] mb-8 transition-colors" data-testid="privacy-back-link">
          <ArrowLeft className="h-4 w-4" />
          {t('privacy.backHome')}
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <Shield className="h-8 w-8 text-[#FFC107]" />
          <h1 className="text-3xl sm:text-4xl font-bold uppercase tracking-tight text-white font-['Barlow_Condensed']">
            {t('privacy.title')}
          </h1>
        </div>
        <p className="text-zinc-400 text-sm mb-10">{t('privacy.lastUpdated')}</p>

        <div className="space-y-8">
          {Array.isArray(sections) && sections.map((section, index) => (
            <div key={index} className="border-b border-[#27272A] pb-8 last:border-0">
              <h2 className="text-lg font-semibold text-white mb-3">{section.heading}</h2>
              <p className="text-zinc-400 text-sm leading-relaxed whitespace-pre-line">{section.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-5 rounded-xl bg-[#141417] border border-[#27272A]">
          <p className="text-zinc-400 text-sm">
            {t('privacy.contactNote')}{' '}
            <a href="mailto:contact@tastybiteslugano.ch" className="text-[#FFC107] hover:underline">
              contact@tastybiteslugano.ch
            </a>
          </p>
        </div>

        <div className="mt-6 flex gap-4 text-sm">
          <Link to="/" className="text-zinc-500 hover:text-[#FFC107] transition-colors">{t('nav.home')}</Link>
          <Link to="/menu" className="text-zinc-500 hover:text-[#FFC107] transition-colors">{t('nav.menu')}</Link>
          <Link to="/contact" className="text-zinc-500 hover:text-[#FFC107] transition-colors">{t('nav.contact')}</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
